(function() {

  'use strict';

  angular.module('itxApp.common')
      .component('preloaderV19', {
          bindings: {
            show: '<',
            ratioClass: '<',
            widthClass: '<',
            theme: '<'
          },
          template:
          '<div class="row cmp-preloader-v19 {{::$ctrl.theme}}" ng-show="$ctrl.show">'+
            '<div class="{{::$ctrl.widthClass}} center-loader">'+
              '<div class="{{::$ctrl.ratioClass}}">'+
                '<div class="absolute-middle">'+
                  '<div id="wrapper">'+
                    '<div class="profile-main-loader">'+
                      '<div class="loader">'+
                        '<svg class="circular-loader"viewBox="25 25 50 50" >'+
                          '<circle class="loader-path" cx="50" cy="50" r="20" fill="none" stroke="#000" stroke-width="2" />'+
                        '</svg>'+
                        // '<img ng-src="{{::$ctrl.logoSrc}}" alt="">'+
                      '</div>'+
                    '</div>'+
                  '</div>'+
                '</div>'+
              '</div>'+
            '</div>'+
          '</div>',
          controller: function() {

            var _this = this;

            _this.logoSrc = '';

            _this.$onInit = function () {

              if(!_this.widthClass) {
                _this.widthClass = 'cmp-width';
              }

              if(!_this.ratioClass) {
                _this.ratioClass = 'cmp-height';
              }

              // if(_this.theme == 'dark'){
              //   _this.logoSrc = "https://axinstgeccihs2.central.inditex.grp/3/static2/itxwebstandard/images/logdu-white.png";
              // } else{
              //   _this.logoSrc = "https://axinstgeccihs2.central.inditex.grp/3/static2/itxwebstandard/images/logdu.png";
              // }
            };
          }
        });

})();